<script> 
    import Card from "./card.svelte";
    import { onMount } from "svelte";  
    import wrappedFetch from "../../wrappedFetch.js";

    export let pupilLogsURL="";
    export let staffLogsURL="";
    export let staffPendingrequestURL="";
    export let params; 
    export let parentComponent="" ;
    let providerId = 0;
    let staffPendingCount = 0;
    let pupilPendingCount = 0;
    // if (params == null)
    // {
    //     params={pupilsProcessed : 5,pupilsPending:10,pupilsErrors:0,staffProcessed:2,staffPending:5,staffErrors:0}
    // }

    //retrieve all entries in the pendingUsers table (users to have actions taken on them) and filter how many staff and students we have
    const getNumbersForLogs = async () => {
    let resp = await wrappedFetch(
      `/api/cloudConfig/GetPendingUsersForLogs?providerId=${providerId}`,
      { method: 'post' }
    );

    let answerFromMethod = await resp.json();

    answerFromMethod.forEach((entry) => {
    // Check the role field and increment the corresponding counter
        if (entry.role === "Staff" && entry.action === 0) {
            staffPendingCount++;
        } else if (entry.role === "Pupil" && entry.action === 0) {
            pupilPendingCount++;
        }
    });
    
  };

    onMount(async () => {
        //retrieve the current pages URL
        const currentURL = window.location.href;

        //split the url
        const parts = currentURL.split('/');

        //extract the provider id from URL
        providerId = parseInt(parts[5]);

        //make sure that the is a valid providerId that we expected (1 for Google or 3 for Microsoft)
        if (providerId == 1 || providerId == 3) {
            getNumbersForLogs();
        }
        
    });


</script>
<style>
     .error{
        color: red;
        font-weight: 500;
    }
    .processed{
        color: #2b76e9;
        font-weight: 500;
    }
    .pending{
        color:orange;  /* rgb(236, 80, 76); */
        font-weight: 500;
    }  
    .material-icons{
        vertical-align: bottom;
    }
     .btn{
        color: #2e817d;
        border: 1px solid #2e817d;
        margin-top: 20%;
    }
    h5{
        color: #2e817d; /*  #ec504c; */
    }
</style>
<slot name="header"/>

<Card>
    <div slot="body">
        <div style="float: left;">
            <h5>
                <span class="material-icons">school</span>
                Pupil
            </h5>
            {#if parentComponent =="export"}
                <p>
                    <!-- On the last export there were <span class="processed">{params.pupilsProcessed}</span> new records processed 
                    with <span class="pending">{params.pupilsPending}</span> awaiting to be matched 
                    and <span class="error">{params.pupilsErrors}</span> errors.</p> -->
                    There are <span class="pending">{pupilPendingCount}</span> pupils awaiting to be matched.
                </p>
            {/if}
            {#if parentComponent =="import"}
                <p><span class="processed">{params.pupilsProcessed}</span> records processed with <span class="pending">{params.pupilsPending}</span> awaiting to be matched and <span class="error">{params.pupilsErrors}</span> errors.</p>
            {/if}
          
    </div>
    <div style="float: right;">
        <a class="btn" href={pupilLogsURL}>Show</a>
    </div>
    </div>
</Card>
<br/>
<Card>
    <div slot="body">
        <div style="float: left;">
            <h5>
                <span class="material-icons">assignment_ind</span>
                Staff
            </h5>
            {#if parentComponent =="export"}
                <p>
                    <!-- On the last export there were <span class="processed">{params.staffProcessed}</span> new records processed 
                    with <span class="pending">{params.staffPending}</span> awaiting to be matched 
                    and <span class="error">{params.staffErrors}</span> errors. -->
                    There are <span class="pending">{staffPendingCount}</span> staff awaiting to be matched.
                </p>
            {/if}
            {#if parentComponent =="import"}
            <p><span class="processed">{params.staffProcessed}</span> records processed with <span class="pending">{params.staffPending}</span> awaiting to be matched and <span class="error">{params.staffErrors}</span> errors.</p>
            {/if}
           
    </div>
    <div style="float: right;">
        <a class="btn" href={staffLogsURL}>Show</a>
    </div>
    </div>
</Card>
{#if staffPendingrequestURL!= ""}
<br/>
<Card>
    <div slot="body">
        <div style="float: left;">
            <h5>
                <span class="material-icons">pending_actions</span>
                Staff Pending Requests
            </h5>
          
            <p><span class="processed">{params.requestsMade}</span> requests initiated and <span class="pending">{params.requestsReceived}</span> requests received.</p>
          
        </div>
        <div style="float: right;">
        <a class="btn" href={staffPendingrequestURL}>Show</a>
        </div>
    </div>
</Card>
{/if}
